import type { FeatureFlagName } from "~/gql/graphqlBase.generated";

import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface FeatureFlagCacheState {
	enabledByFlag: Partial<Record<FeatureFlagName, boolean>>;
	tenantId: string;
}

export interface FeatureFlagCacheRootState {
	featureFlagCache: FeatureFlagCacheState;
}

interface RememberFeatureFlagPayload {
	enabled: boolean;
	name: FeatureFlagName;
	tenantId: string;
}

const initialState: FeatureFlagCacheState = {
	enabledByFlag: {},
	tenantId: ""
};

export const featureFlagCacheSlice = createSlice({
	initialState,
	name: "featureFlagCache",
	reducers: {
		rememberFeatureFlag: (state, action: PayloadAction<RememberFeatureFlagPayload>) => {
			const { enabled, name, tenantId } = action.payload;
			if (state.tenantId !== tenantId) {
				state.enabledByFlag = {};
				state.tenantId = tenantId;
			}
			state.enabledByFlag[name] = enabled;
		}
	}
});

export const { rememberFeatureFlag } = featureFlagCacheSlice.actions;

export const selectLastKnownFeatureFlag =
	(name: FeatureFlagName, tenantId: string) =>
	(state: FeatureFlagCacheRootState): boolean | undefined => {
		const cache = state.featureFlagCache;
		if (!tenantId || cache.tenantId !== tenantId) return undefined;
		return cache.enabledByFlag[name];
	};

export default featureFlagCacheSlice.reducer;
